import { PieChart } from "@mui/x-charts";
import { SettingsStatisticsConfiguration } from "../../../../../utils/configurationProvider";

const CommonPieChart = ({ dataArray }) => {
  const seriesData = {
    series: [
      {
        id: "outer",
        innerRadius: SettingsStatisticsConfiguration.pieChartInnerRadius,
        outerRadius: SettingsStatisticsConfiguration.pieChartOuterRadius,
        data: dataArray,
        highlightScope: { fade: "global", highlight: "item" },
        arcLabel: () => "",
      },
    ],
    slotProps: { legend: { hidden: true } },
    margin: {
      top: SettingsStatisticsConfiguration.zeroStrokeWidthForLineGraph,
      right: SettingsStatisticsConfiguration.zeroStrokeWidthForLineGraph,
      bottom: SettingsStatisticsConfiguration.zeroStrokeWidthForLineGraph,
      left: SettingsStatisticsConfiguration.zeroStrokeWidthForLineGraph,
    },
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "var(--statistic-graph-height)",
        width: "var(--width-full)",
      }}
    >
      <PieChart
        {...seriesData}
        sx={{
          "& .MuiPieArc-root": { stroke: "none" },
          '& [data-series-id="outer"] .MuiPieArc-root': {
            opacity: "var(--light-opacity)",
          },
        }}
      />
    </div>
  );
};

export default CommonPieChart;
